<template>
    <div class="c-grocery-list">
    <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="view__container order-1 d-print-none" v-show="items.length" v-cloak>
                    
            <ul class="filters list-unstyled list-inline">
                <div class="list-inline-item"><span>View:</span></div>
                <li class="list-inline-item"><button class="btn" @click="visibility = 'all'; showFilterBtnStyle()">All</button></li>
                <li class="list-inline-item"><button class="btn " @click="visibility = 'active'; showFilterBtnStyle()">Active</button></li>
                <li class="list-inline-item"><button class="btn " @click="visibility = 'completed'; showFilterBtnStyle()">Completed</button></li>
            
            </ul>
        </div>
        <div class="h3 mt-3">Items:<aha-grocery-count></aha-grocery-count></div>
    </div>
        
        <slot name="header"></slot>
        <div v-show="items.length === 0">
            <slot name="error">
                <h2 class="text-primary">No items found.</h2>
            </slot>
        </div>
        <div class="c-grocery-list__container" v-show="items.length" v-cloak>
            <div class="completed__container d-flex justify-content-between d-print-none">
                <input type="checkbox" id="toggle-all" class="toggle-all" v-model="allDone">
                <label @click="checkAll" for="toggle-all">{{ checked }}</label>
                <button class="btn clear-completed" @click.prevent="removeCompleted">Clear Completed</button>
            </div>
            <ul class="grocery-list list-unstyled">
                <li v-for="item in filteredItems" 
                :key="item.id"

                :class="{completed: item.completed}"
                >
                    <div class="view">
                        <input @click="checkAllItems" :id="item.id" type="checkbox" class="toggle" v-model="item.completed"/>
                         
                        <label :for="item.id">{{item.ProductName}}</label>
                        <button class="destroy d-print-none" @click="removeItem(item)"></button>
                    </div>
                </li>
            </ul>
        </div>

        

        
    </div> 
</template>

<script>



// const STORAGE_KEY = "grocery-list";
// const itemsStorage = {
//     fetch: function() {
//         var items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//         items.forEach((item,index) => {
//            item.id = index;
//         });
//         itemsStorage.uid = items.length;
//         return items;
//     },
//     save: function(items) {
//         localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
//     }
// };

// const filters = {
//     all: function(items) {
//         return items;
//     },
//     active: function(items) {
//         return items.filter(item => {
//             return !item.completed;
//         })
//     },
//     completed: function(items) {
//         return items.filter(item => {
//             return item.completed;
//         })
//     }
// };
import {itemsStorageFunc, itemsStorageFilters} from '@/utils/items-storage';
const STORAGE_KEY = '_aha-coveo-grocery-list';
export default {
    props: {
        title: {
            type: String,
            required: false,
            default: "My Grocery List"
        },
        count: {
            type: Number
        }
    },
    data() {
        return {
            items: [],
            newItem: "",
            editedItem: null,
            visibility: "all",
            checked: ""        
        }
    },
    // watch todos change for localStorage persistence
    watch: {
        items: {
            handler: function(items) {
                itemsStorageFunc.save(STORAGE_KEY, items)
                this.$eventHub.$emit('grocerylist::updated', this.remaining);
                
                const modal = document.querySelector('#GroceryListModal .modal-content'); // select the modal by it's id
                modal.addEventListener('keydown', function(e) {

                    // Focus trapp below: add all the elements inside modal which you want to make focusable
                    const  focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                    

                    let firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                    let focusableContent = modal.querySelectorAll(focusableElements);
                    let lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                    let list = Array.from(focusableContent)
                    const index = list.findIndex(content => content === document.activeElement);

                    //console.log(list[index], index, list[index + 1]); // 1
                    //console.log('i',index)

                    if(list[index]) {
                        list[index].addEventListener('click', function(){
                            list[index + 1].focus()
                        })
                    }


                    if (e.key !== 'Tab') {
                        return;
                    } 

                    if (document.activeElement === firstFocusableElement && items.length === 0){
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                    }

                    if (e.shiftKey) { // if shift key pressed for shift + tab combination
                        if (document.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus(); // add focus for the last focusable element
                            e.preventDefault();
                        }
                    } else { // if tab key is pressed
                        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                            firstFocusableElement.focus(); // add focus for the first focusable element
                            e.preventDefault();
                        } 
                    }


                    const closeBtn = document.querySelector('#GroceryListModal___BV_modal_header_ .close')
                    closeBtn.addEventListener('click', function(){
                        setTimeout(function(){ 
                            document.querySelector('.coveo-results-header button.coveo-results-add-to-list').focus();
                        },0)
                    })


                });



                // Lines below hide email section of grocery list modal where there are no items remaining

                const privacyPolicy = document.getElementsByClassName('message')
                const emailSelector = document.getElementById('grocery-list-email');

                if(this.remaining === 0){
                    privacyPolicy[0].setAttribute("style", "visibility: hidden; height:0;");
                    emailSelector.setAttribute("style", "visibility: hidden; height:0;");
                } else {
                    privacyPolicy[0].setAttribute("style", "visibility: visible; height:auto;");
                    emailSelector.setAttribute("style", "visibility: visible; height:auto;");
                }

            },
            deep: true
        }

    },
    computed: {
        filteredItems: function() {
            return itemsStorageFilters[this.visibility](this.items);
        },
        remaining: function() {
            return itemsStorageFilters.active(this.items).length;
        },
        allDone: {
            get: function() {
                return this.remaining === 0;
            },
            set: function(value) {
                this.items.forEach(item => {
                    item.completed = value
                });
            }
        },
    },
    created() {
        
    },
    mounted() {
        this.items = itemsStorageFunc.fetch(STORAGE_KEY);  
        if(this.remaining === 0){
            this.checked = "Uncheck All"  
        } else {
            this.checked = "Check All"
        };
        
        const allFilterBtn = document.querySelector('.filters li:nth-child(2) .btn')
        allFilterBtn.classList.add('activeFilter')

        console.log(this.remaining)
    },
    filters: {
        pluralize: function(n) {
            return n === 1 ? "item" : "items";
        }
    },
    methods: {  
        showFilterBtnStyle: function(){
            // show indication of what filter tab the user is actively on.
            const allFilterBtn = document.querySelector('.filters li:nth-child(2) .btn')
            const activeFilterBtn = document.querySelector('.filters li:nth-child(3) .btn')
            const completedFilterBtn = document.querySelector('.filters li:nth-child(4) .btn')

            if(this.visibility){
                if(this.visibility === 'all'){
                    allFilterBtn.classList.add('activeFilter')
                    activeFilterBtn.classList.remove('activeFilter')
                    completedFilterBtn.classList.remove('activeFilter')
                }
                if(this.visibility === 'active'){
                    allFilterBtn.classList.remove('activeFilter')
                    activeFilterBtn.classList.add('activeFilter')
                    completedFilterBtn.classList.remove('activeFilter')
                }
                if(this.visibility === 'completed'){
                    allFilterBtn.classList.remove('activeFilter')
                    activeFilterBtn.classList.remove('activeFilter')
                    completedFilterBtn.classList.add('activeFilter')
                }
            }
        },       
        addItem: function(value) {
            // var value = this.newItem && this.newItem.trim();
            /*if (!value) {
                return
            };*/
            this.items.push({
                ProductName: value,
                completed: false,
                id: itemsStorageFunc.uid++
            });
            this.newItem = "";
        },
        removeItem: function(item) {
            this.items.splice(this.items.indexOf(item),  1);
        },
        editItem: function(item) {
            this.beforeEditCache = item.title;
            this.editedItem = item;
        },
        doneEdit: function(item) {
            if (!this.editedItem) {
                return;
            }
            this.editedItem = null;
            item.title = item.title.trim();
            if (!item.title) {
                this.removeItem(item)
            }
        },
        cancelEdit: function(item) {
            this.editedItem = null;
            item.title = this.beforeEditCache;
        },
        removeCompleted: function(item, value) {
            let checkedItems = document.querySelectorAll("ul.grocery-list li.completed")
            let checkedBoxItems = document.querySelectorAll("ul.grocery-list li input[type='checkbox']")


            //unchecks checkboxes, removes class, sets check All, sets item back
            checkedBoxItems.forEach(checkedBoxItem => {checkedBoxItem.checked = false;})
            checkedItems.forEach(checkedItem => {checkedItem.classList.remove("completed");})
            this.checked = "Check All"
            this.items.forEach(item => {
                    item.completed = value
            });

            // focus on the "completed" button once completed items are cleared with the "clear completed" btn
            // let clearCompleteBtn = document.querySelector('.clear-completed')
            // clearCompleteBtn.addEventListener('click', () => {
            //     let completedFilterBtn = document.querySelector('.filters li:nth-child(4) .btn')
            //     completedFilterBtn.focus();
            // })

            //removes all checked items
            //this.items = itemsStorageFilters.active(this.items)
        },
        checkAll: function(item){
            if(this.remaining === 0){
                this.checked = "Check All"
            } else {
                this.checked = "Uncheck All"
            }
        },
        checkAllItems: function(){
            var checkboxes = document.querySelectorAll("ul.grocery-list li input[type='checkbox']").length;
            var checkboxesChecked = document.querySelectorAll("ul.grocery-list li input[type='checkbox']:checked").length;

            if(checkboxesChecked === checkboxes) {
                this.checked = "Uncheck All"
            } else {
                this.checked = "Check All"
            }
        }
    },
}
</script>




// WEBPACK FOOTER //
// src/app/components/aha-grocery-list.vue